import React from 'react';
import { X, AlertTriangle } from 'lucide-react';
import './LossModal.css';

const LossModal = ({ isOpen, onClose, students }) => {
    if (!isOpen) return null;

    return (
        <div className="modal-overlay" onClick={onClose}>
            <div className="modal-content" onClick={(e) => e.stopPropagation()}>
                <div className="modal-header">
                    <div className="modal-title-group">
                        <AlertTriangle size={24} className="warning-icon" />
                        <h2>Loss-Making Students</h2>
                    </div>
                    <button className="close-btn" onClick={onClose}>
                        <X size={20} />
                    </button>
                </div>

                <div className="modal-body">
                    <p className="modal-description">
                        The following {students.length} students have exceeded their package lesson limits,
                        resulting in additional costs to the business.
                    </p>

                    <div className="students-table">
                        <div className="table-header">
                            <div>Student ID</div>
                            <div>Name</div>
                            <div>Package</div>
                            <div>Lessons Limit</div>
                            <div>Completed</div>
                            <div>Excess</div>
                            <div>Branch</div>
                        </div>
                        {students.map(student => (
                            <div key={student.id} className="table-row">
                                <div>{student.studentId}</div>
                                <div className="student-name">{student.name}</div>
                                <div>{student.packageName}</div>
                                <div>{student.packageLessons}</div>
                                <div className="completed">{student.lessonsCompleted}</div>
                                <div className="excess">+{student.excessLessons}</div>
                                <div>{student.branch}</div>
                            </div>
                        ))}
                    </div>
                </div>

                <div className="modal-footer">
                    <button className="btn-secondary" onClick={onClose}>Close</button>
                    <button className="btn-primary">Export Report</button>
                </div>
            </div>
        </div>
    );
};

export default LossModal;
